// © 2025 Camp Promethean, LLC. All Rights Reserved.

import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem
      storageKey="cp-color-mode"
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
